import React from 'react'
import { createRoot } from 'react-dom/client'
import { StateProvider } from '@State'
import { Application } from './components/App'

const pathArray = window.location.pathname.split('/')
const coursenum = pathArray[3]

const initialState = {
  coursenum,
  canvasCoursenum: '',
  canvasUrl: '',
  courseTitle: '',
  courseToken: '',
  courseList: [],
  launchToolCreated: '',
  selectedLms: '',
  assessments: {},
  formErrorMsg: '',
  msgClass: 'danger',
  selectErrorMsg: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHOOSE_LMS': // only used when we start using the LMSChooser Component
      return {
        ...state,
        lms: action.payload,
      }
    case 'UPDATE_LMS_DATA':
      return {
        ...state,
        canvasCoursenum: action.canvasCoursenum,
        canvasUrl: action.canvasUrl,
        courseTitle: action.courseTitle,
      }
    case 'UPDATE_LMS_TOKEN':
      return {
        ...state,
        courseToken: action.courseToken,
      }
    case 'SET_LMS_COURSE_LIST':
      return {
        ...state,
        courseList: action.courseList,
      }
    case 'UPDATE_LAUNCH_TOOL_CREATED':
      return {
        ...state,
        launchToolCreated: action.launchToolCreated,
      }
    case 'UPDATE_SELECTED_LMS':
      return {
        ...state,
        selectedLms: action.selectedLms,
      }
    case 'UPDATE_ASSESSMENTS':
      return {
        ...state,
        assessments: action.assessments,
      }
    case 'UPDATE_BRIGHTSPACE_CONFIGURATION':
      return {
        ...state,
        brightspaceAKPConfigured: action.configured,
      }
    case 'UPDATE_FORM_ERROR':
      return {
        ...state,
        formErrorMsg: action.formErrorMsg,
        msgClass: action.msgClass,
      }
    case 'UPDATE_SELECT_FORM_ERROR':
      return {
        ...state,
        selectErrorMsg: action.selectErrorMsg,
      }
    default:
      return state
  }
}

export let startLmsApp = () => {
  let appNode = document.getElementById('app')
  const root = createRoot(appNode)
  root.render(
    <StateProvider reducer={reducer} initialState={initialState}>
      <Application />
    </StateProvider>
  )
}
